<template>
  <el-card shadow="never" class="aui-card--fill">
    <div class="mod-trade__worklog}">
      <el-form
        :inline="true"
        :model="dataForm"
        @keyup.enter.native="getDataList()"
      >
        <el-form-item label="合同编号：">
          <el-input
            v-model="dataForm.agreementCode"
            placeholder="合同编号"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item label="员工：" prop="workerId">
          <CommonDrop
            v-model="dataForm.workerId"
            url="/trade/worker/list"
            :autoDefault="false"
          ></CommonDrop>
        </el-form-item>
        <el-form-item>
          <el-button @click="getDataList()">{{ $t("query") }}</el-button>
        </el-form-item>
        <el-form-item>
          <el-button
            v-if="$hasPermission('trade:worklog:save')"
            type="primary"
            @click="addOrUpdateHandle()"
            >上传工票</el-button
          >
        </el-form-item>
      </el-form>
      <el-table
        v-loading="dataListLoading"
        :data="dataList"
        border
        @selection-change="dataListSelectionChangeHandle"
        style="width: 100%;"
      >
        <el-table-column
          type="index"
          label="行号"
          header-align="center"
          align="center"
          width="50"
        ></el-table-column>
        <el-table-column
          prop="agreementCode"
          label="合同编号"
          header-align="center"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="workerName"
          label="员工姓名"
          header-align="center"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="productCode"
          label="品番号"
          header-align="center"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="productName"
          label="品名"
          header-align="center"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="color"
          label="颜色"
          header-align="center"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="size"
          label="规格"
          header-align="center"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="technologyName"
          label="工序"
          header-align="center"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="count"
          label="数量"
          header-align="center"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="price"
          label="单价"
          header-align="center"
          align="center"
        ></el-table-column>
        <el-table-column
          label="总价"
          header-align="center"
          align="center"
        >
        <template slot-scope="scope">
          {{scope.row.count*scope.row.price}}
        </template>
        </el-table-column>
        <el-table-column
          prop="workDay"
          label="工作时间"
          header-align="center"
          align="center"
        ></el-table-column>

        <el-table-column
          :label="$t('handle')"
          fixed="right"
          header-align="center"
          align="center"
          width="150"
        >
          <template slot-scope="scope">
            <el-button
              v-if="$hasPermission('trade:worklog:delete')"
              type="text"
              size="small"
              @click="deleteHandle(scope.row.id)"
              >{{ $t("delete") }}</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        :current-page="page"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="limit"
        :total="total"
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="pageSizeChangeHandle"
        @current-change="pageCurrentChangeHandle"
      >
      </el-pagination>
      <!-- 弹窗, 新增 / 修改 -->
      <add-or-update
        v-if="addOrUpdateVisible"
        ref="addOrUpdate"
        @refreshDataList="getDataList"
      ></add-or-update>
    </div>
  </el-card>
</template>

<script>
import CommonDrop from "@/components/CommonDrop";
import mixinViewModule from "@/mixins/view-module";
import AddOrUpdate from "./add-or-update";
export default {
  mixins: [mixinViewModule],
  components: {
    AddOrUpdate,
    CommonDrop
  },
  data() {
    return {
      mixinViewModuleOptions: {
        getDataListURL: "/trade/worklog/page",
        getDataListIsPage: true,
        exportURL: "/trade/worklog/export",
        deleteURL: "/trade/worklog",
        deleteIsBatch: true,
      },
      dataForm: {
        workerId: "",
        agreementCode: "",
      },
    };
  },
};
</script>
